module.exports = __webpack_public_path__ + "img/02.1da14670.png";